import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HtmlRenderService {
  rendering = new BehaviorSubject<boolean>(false);
}
